import { supabase } from '../lib/supabase';

export const serviceZoneService = {
  async getAllZones() {
    const { data, error } = await supabase?.from('service_zones')?.select('*')?.order('priority', { ascending: true })?.order('name', { ascending: true });

    if (error) throw error;

    return data?.map(zone => ({
      id: zone?.id,
      name: zone?.name,
      postalCode: zone?.postal_code,
      municipalityName: zone?.municipality_name,
      latitude: zone?.latitude,
      longitude: zone?.longitude,
      radiusKm: zone?.radius_km,
      isActive: zone?.is_active,
      priority: zone?.priority,
      notes: zone?.notes,
      createdAt: zone?.created_at,
      updatedAt: zone?.updated_at
    }));
  },

  async getActiveZones() {
    const { data, error } = await supabase?.from('service_zones')?.select('*')?.eq('is_active', true)?.order('priority', { ascending: true });

    if (error) throw error;

    return data?.map(zone => ({
      id: zone?.id,
      name: zone?.name,
      postalCode: zone?.postal_code,
      municipalityName: zone?.municipality_name,
      latitude: zone?.latitude,
      longitude: zone?.longitude,
      radiusKm: zone?.radius_km,
      priority: zone?.priority
    }));
  },

  async validateLocation(postalCode, municipalityName, latitude, longitude) {
    const { data, error } = await supabase?.rpc('is_location_in_service_zone', {
        check_postal_code: postalCode || null,
        check_municipality: municipalityName || null,
        check_latitude: latitude || null,
        check_longitude: longitude || null
      });

    if (error) throw error;
    return data;
  },

  async getNearestZone(latitude, longitude) {
    const { data, error } = await supabase?.rpc('get_nearest_service_zone', {
        check_latitude: latitude,
        check_longitude: longitude
      });

    if (error) throw error;

    if (data && data?.length > 0) {
      return {
        zoneId: data?.[0]?.zone_id,
        zoneName: data?.[0]?.zone_name,
        distanceKm: data?.[0]?.distance_km
      };
    }

    return null;
  },

  async createZone(zoneData) {
    const { data, error } = await supabase?.from('service_zones')?.insert({
        name: zoneData?.name,
        postal_code: zoneData?.postalCode || null,
        municipality_name: zoneData?.municipalityName || null,
        latitude: zoneData?.latitude || null,
        longitude: zoneData?.longitude || null,
        radius_km: zoneData?.radiusKm || 5.0,
        is_active: zoneData?.isActive !== undefined ? zoneData?.isActive : true,
        priority: zoneData?.priority || 1,
        notes: zoneData?.notes || null
      })?.select()?.single();

    if (error) throw error;

    return {
      id: data?.id,
      name: data?.name,
      postalCode: data?.postal_code,
      municipalityName: data?.municipality_name,
      latitude: data?.latitude,
      longitude: data?.longitude,
      radiusKm: data?.radius_km,
      isActive: data?.is_active,
      priority: data?.priority,
      notes: data?.notes
    };
  },

  async updateZone(zoneId, zoneData) {
    const { data, error } = await supabase?.from('service_zones')?.update({
        name: zoneData?.name,
        postal_code: zoneData?.postalCode || null,
        municipality_name: zoneData?.municipalityName || null,
        latitude: zoneData?.latitude || null,
        longitude: zoneData?.longitude || null,
        radius_km: zoneData?.radiusKm,
        is_active: zoneData?.isActive,
        priority: zoneData?.priority,
        notes: zoneData?.notes || null
      })?.eq('id', zoneId)?.select()?.single();

    if (error) throw error;

    return {
      id: data?.id,
      name: data?.name,
      postalCode: data?.postal_code,
      municipalityName: data?.municipality_name,
      latitude: data?.latitude,
      longitude: data?.longitude,
      radiusKm: data?.radius_km,
      isActive: data?.is_active,
      priority: data?.priority,
      notes: data?.notes
    };
  },

  async deleteZone(zoneId) {
    const { error } = await supabase?.from('service_zones')?.delete()?.eq('id', zoneId);

    if (error) throw error;
  },

  async toggleZoneStatus(zoneId, isActive) {
    const { data, error } = await supabase?.from('service_zones')?.update({ is_active: isActive })?.eq('id', zoneId)?.select()?.single();

    if (error) throw error;
    return data;
  }
};

export const emailNotificationService = {
  async sendBookingNotification(appointmentData, notificationType) {
    const { data, error } = await supabase?.functions?.invoke('send-booking-notification', {
      body: {
        appointmentData,
        notificationType
      }
    });

    if (error) throw error;
    return data;
  }
};